/**
 * admin路由判断
 */
function useAdminGuard(router) {
  router.beforeEach(async (to, from, next) => {
    if (to.path === '/admin') {
        return location.href = '/admin/'
    }
    next()
  })
}
export default useAdminGuard
